import React from 'react';
import styled, { css } from 'styled-components/macro';

interface Props {
    children: JSX.Element;
    className?: string;
    inlineButtons?: boolean;
}

export const CustomFooter = (props: Props): JSX.Element => {
    return (
        <S_CustomFooter $inlineButtons={props.inlineButtons} className={props.className}>
            {props.children}
        </S_CustomFooter>
    );
};

const S_CustomFooter = styled.div<{ $inlineButtons?: boolean }>`
    display: flex;
    height: 75px;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    ${(props) => {
        if (props.$inlineButtons) {
            return css`
                height: 45px;
            `;
        }
    }}
`;
